import { capitalize } from "@sellar-io/common";
import dayjs from "dayjs";
import { ORDER_DETAILS } from "../../../../constants/routes";
import { OrderListOrder } from "./orderListElementTypes";

const DELIVERY_LABELS: Partial<
  Record<OrderListOrder["fulfillmentType"], string>
> = {
  collection: "Customer collection",
  apc: "Delivery: APC",
  ups: "Delivery: UPS",
  haulier: "Delivery: Pallet",
  sellarDistribution: "Delivery: Sellar",
  dx: "Delivery: DX",
  dxDropOff: "Delivery: DX",
};

export const formatOrderListDate = (date: Date | null) =>
  date ? dayjs(date).format("DD/MM/YYYY") : "-";

export const getOrderDeliveryLabel = (order: OrderListOrder) =>
  DELIVERY_LABELS[order.fulfillmentType] ??
  `Delivery: ${capitalize(order.fulfillmentType)}`;

export const getOrderListUrl = (order: OrderListOrder) =>
  `${ORDER_DETAILS.href({ orderId: order.id })}${location.search}`;
